// extracted by mini-css-extract-plugin
export default {"container":"Wave_container__bI02S","waving":"Wave_waving__Qw87k"};